import { LandToken } from "../types/LandToken";

type Variant = "thumb" | "poster" | "full";

/**
 * Pick the right image rendition for a surface, falling back to the next-best
 * available so nothing breaks before the backend backfills every land.
 *   thumb  → markers, thumbnail strip   (smallest static WebP, ≤256px)
 *   poster → popup card / mobile hero   (static WebP, ≤768px)
 *   full   → detail view (optimized animated rendition if present, else original GIF)
 *
 * `contentThumb`/`contentPoster`/`contentAnimated` are null for tokens minted
 * before the backend rendition change; the `||` chain transparently upgrades to
 * the resized assets once they're backfilled.
 */
export function landImageSrc(
  token: Partial<LandToken> | undefined,
  variant: Variant,
): string | undefined {
  if (!token) return undefined;
  if (variant === "thumb") return token.contentThumb || token.contentPoster || token.content;
  if (variant === "poster") return token.contentPoster || token.content;
  return token.contentAnimated || token.content;
}
